




import { Component, Prop, Vue } from "vue-property-decorator";
import { ISortParameters, IWallet } from "@/interfaces";
import { IPFSService } from "@/services";

@Component
export default class IpfsImage extends Vue {
  @Prop({ required: true }) public hash: string;
  @Prop({ required: false }) public customClass: string;

  private imageData: string = null;

  public async mounted() {
    this.imageData = await IPFSService.fetchData(this.hash);
  }
}
